<template>
  <div id="app">
    <header class="header">
      <router-link :to="{ name: 'home' }"> Dutch Reality Awards </router-link>
    </header>
    <router-view v-if="loaded" />
    <loader v-else />

    <footer>
      <div style="display: flex; justify-content: center; text-align: center">
        <div class="mx-auto w-18 pb-2 text-center">
          <p class="text-sm font-semibold leading-none" style="color: #d9a22e">
            Powered By <span class="sr-only">Angry Bytes</span>
          </p>
          <a href="https://angrybytes.com/" target="_blank" title="Angry Bytes"
            ><svg width="50%" height="50%" viewBox="0 0 753.357 131.043" class="block w-full">
              <path
                fill="#d9a22e"
                d="M4.724 42.922c8.546-5.398 18.442-8.097 29.688-8.097 8.098 0 14.508 2.25 19.23 6.747 4.724 4.499 7.085 11.246 7.085 20.242v40.484H41.835V96.9c-5.489 3.6-10.437 5.398-14.845 5.398-8.997 0-15.745-1.91-20.242-5.734C2.249 92.74 0 87.455 0 80.707 0 74.41 2.126 68.788 6.377 63.84s11.121-7.423 20.613-7.423c4.362 0 9.312 1.35 14.845 4.048v-2.023c-.091-4.948-3.689-7.647-10.796-8.098-8.098 0-14.396 1.35-18.894 4.049L4.724 42.922zm37.111 39.135v-7.624c-1.8-3.463-6.073-5.195-12.82-5.195-8.097.9-12.371 4.049-12.82 9.446.449 5.354 4.724 8.254 12.82 8.703 6.747 0 11.02-1.776 12.82-5.33zM86.815 59.386v42.913H67.923V36.781l18.893-2.023v6.14c4.543-4.048 9.941-6.072 16.194-6.072 8.546 0 15.069 2.587 19.567 7.76s6.748 11.133 6.748 17.88V102.3h-18.894V65.189c0-4.498-1.125-7.984-3.373-10.46-2.25-2.473-5.646-3.778-10.188-3.913-3.914.27-7.266 3.127-10.055 8.57zM199.2 36.85V96.9c0 9.447-2.812 17.342-8.434 23.684-5.624 6.344-12.709 9.693-21.255 10.055l-4.049.404c-13.045-.27-23.167-4.004-30.363-11.201l8.771-10.121c4.948 3.6 10.953 5.623 18.016 6.074 7.197 0 12.066-1.688 14.608-5.061 2.541-3.375 3.812-7.086 3.812-11.135v-3.373c-5.038 4.049-10.887 6.072-17.543 6.072-10.347 0-18.106-3.035-23.279-9.109-5.173-6.072-7.76-14.281-7.76-24.627 0-9.896 2.812-17.993 8.435-24.291s13.606-9.446 23.954-9.446c7.646.45 13.044 2.496 16.193 6.14v-6.14L199.2 36.85zm-18.892 37.785V63.704c-.9-7.558-5.623-11.987-14.17-13.293-11.246.405-17.318 6.006-18.218 16.802.449 12.596 6.521 19.117 18.218 19.566 8.546-1.349 13.269-5.396 14.17-12.144zM220.44 42.247c4.812-4.947 10.683-7.422 17.61-7.422 2.204 0 4.296.18 6.275.539l-2.969 18.623c-2.204-1.979-5.354-3.036-9.446-3.171-4.588.315-8.412 3.644-11.471 9.986v41.496h-18.893V36.781l18.893-2.023v7.489zM288.9 78.953V34.825h18.894V96.9c0 9.447-2.925 17.342-8.771 23.684-5.849 6.344-12.82 9.693-20.918 10.055l-4.048.404c-9.446-.27-17.994-4.004-25.641-11.201l8.771-10.121c5.398 4.049 10.503 6.299 15.317 6.748 5.847 0 10.042-1.463 12.584-4.385 2.54-2.926 3.812-7.086 3.812-12.484v-3.441c-4.769 4.096-10.279 6.141-16.531 6.141-8.547 0-15.069-2.586-19.567-7.76-4.498-5.172-6.747-11.133-6.747-17.881V34.825h18.893v37.111c0 4.498 1.124 7.985 3.374 10.458 2.249 2.475 5.645 3.779 10.188 3.914 3.958-.271 7.422-2.722 10.39-7.355z"
              ></path>
              <g>
                <path
                  fill="#d9a22e"
                  d="M463.46 1.088V40.29c3.148-3.193 8.097-5.015 14.845-5.465 10.346 0 18.555 3.373 24.628 10.121 6.072 6.747 9.109 14.62 9.109 23.616s-3.037 16.867-9.109 23.615c-6.073 6.748-14.282 10.121-24.628 10.121-4.858 0-9.808-1.799-14.845-5.398v5.398h-18.893V1.158l18.893-.067zm14.17 85.691c11.695-.449 17.768-6.971 18.218-19.566-1.35-10.346-7.422-15.946-18.218-16.802-8.548 1.306-13.271 5.735-14.17 13.293v10.931c.899 6.748 5.622 10.795 14.17 12.144zM560.46 78.953V34.825h18.893V96.9c0 9.447-2.925 17.342-8.771 23.684-5.849 6.344-12.82 9.693-20.917 10.055l-4.049.404c-9.446-.27-17.993-4.004-25.641-11.201l8.772-10.121c5.397 4.049 10.502 6.299 15.316 6.748 5.847 0 10.042-1.463 12.584-4.385 2.541-2.926 3.812-7.086 3.812-12.484v-3.441c-4.769 4.096-10.279 6.141-16.531 6.141-8.548 0-15.07-2.586-19.568-7.76-4.498-5.172-6.747-11.133-6.747-17.881V34.825h18.893v37.111c0 4.498 1.124 7.985 3.374 10.458 2.249 2.475 5.645 3.779 10.188 3.914 3.958-.271 7.423-2.722 10.392-7.355zM618.33 102.3c-7.647 0-13.721-2.135-18.218-6.41-4.499-4.273-6.748-9.783-6.748-16.531V50.143h-10.121V34.894h10.121V16.607l18.961-2.024v20.311h10.121v15.249h-10.121V76.66c0 3.6.752 6.131 2.26 7.592 1.507 1.463 3.452 2.193 5.837 2.193.719 0 2.405-.293 5.061-.877l3.98 13.562c-3.238 2.113-6.949 3.17-11.133 3.17zM630.44 68.562c0-9.896 3.148-17.993 9.447-24.291 6.297-6.298 14.394-9.446 24.29-9.446s17.769 3.148 23.616 9.446 8.772 14.396 8.772 24.291v6.747h-46.558c.449 3.599 2.024 6.409 4.723 8.435 2.699 2.023 5.848 3.035 9.446 3.035 6.298 0 11.92-1.797 16.869-5.396l10.796 10.795c-4.949 6.748-14.17 10.121-27.665 10.121-9.896 0-17.993-3.148-24.29-9.445-6.297-6.299-9.446-14.395-9.446-24.292zm43.185-15.181c-2.699-2.024-5.849-3.037-9.447-3.037s-6.747 1.013-9.446 3.037c-2.698 2.023-4.048 4.836-4.048 8.434h26.989c0-3.598-1.35-6.411-4.048-8.434zM742.63 36.714c3.508 1.53 6.791 3.802 9.851 6.815l-10.525 11.875c-3.06-3.644-6.883-5.465-11.471-5.465-4.544 0-7.581.843-9.109 2.53-1.53 1.687-1.53 3.217 0 4.588 1.528 1.373 4.565 2.509 9.109 3.407 6.702.631 12.189 2.543 16.464 5.736 4.272 3.194 6.409 8.749 6.409 16.666 0 6.387-2.52 11.336-7.557 14.844-5.038 3.508-10.909 5.264-17.611 5.264-6.388 0-11.706-.912-15.957-2.732-4.251-1.822-7.906-4.262-10.965-7.322l10.458-11.809c3.059 3.645 7.805 5.76 14.237 6.344 5.173 0 8.513-.844 10.021-2.531 1.507-1.686 1.73-3.373.675-5.061-1.058-1.686-4.622-2.822-10.695-3.406-5.488-.63-10.516-2.316-15.08-5.061-4.566-2.743-6.849-7.917-6.849-15.52 0-6.972 2.598-12.291 7.793-15.958 5.195-3.665 10.537-5.499 16.025-5.499 6.342.001 11.268.767 14.777 2.295z"
                ></path>
              </g>
              <path
                fill="#d9a22e"
                d="M429.74 32.746c0 29.939-24.383 98.289-54.463 98.289-30.076 0-54.461-68.35-54.461-98.289C320.816 2.805 345.201 0 375.277 0c30.08 0 54.463 2.805 54.463 32.746m-62.626 13.147l-23.659.936 18.588 14.604-6.417 22.689 19.693-13.087 19.694 13.087-6.415-22.69 18.588-14.604-23.66-.936-8.206-22.111-8.206 22.112z"
              ></path></svg
          ></a>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import Loader from './components/Loader'
import { get } from './util/request'
import { SORT_RANDOM } from '@/sortTypes'
import slugify from 'slugify'
import category from './components/Category.vue'

const { CDN_DOMAIN } = process.env

export default {
  name: 'app',
  components: {
    loader: Loader,
  },
  computed: {
    loaded() {
      return this.$store.state.loaded
    },
  },
  mounted() {
    get(`voting/round`)
      .then((response) => response.json())
      .then((data) => {
        const rounds = Object.values(data || {}).map(
          ({ id, name, description, categories, suggestions_max, allow_suggestions }) => {
            return {
              id: Number(id),
              name,
              description,
              image: null,
              categoryIds: categories.data.map(({ id }) => Number(id)),
              suggestions_max,
              allow_suggestions,
            }
          }
        )
        this.$store.dispatch(
          'setAllowSuggestions',
          rounds[0].allow_suggestions && rounds[0].suggestions_max > 0
        )

        const categories = data.data.categories.data.map(({ id, name }) => {
          if (name.includes(' | ')) {
            const categoryText = name.split(' | ')
            return {
              id: Number(id),
              name: categoryText[0],
              placeholder: categoryText[1],
              slug: slugify(name, { lower: true, remove: /[/:]/g }),
              nomineeIds: data.data.nominees.data
                .filter((nominee) => nominee.categories.includes(Number(id)))
                .map(({ id }) => Number(id)),
              round: {},
              sortType: SORT_RANDOM,
              selectedChannelId: null,
              selectedDayPartId: null,
              keyword: '',
            }
          } else {
            return {
              id: Number(id),
              name: name,
              slug: slugify(name, { lower: true }),
              nomineeIds: data.data.nominees.data
                .filter((nominee) => nominee.categories.includes(Number(id)))
                .map(({ id }) => Number(id)),
              round: {},
              sortType: SORT_RANDOM,
              selectedChannelId: null,
              selectedDayPartId: null,
              keyword: '',
            }
          }
        })

        let nominees = []

        data.data.nominees.data.forEach((nominee) => {
          nominee.categories.forEach((nomineeCategory) => {
            const src = nominee.image ? nominee.image.data.src : null

            nominees.push({
              id: Number(nominee.id),
              name: nominee.name,
              slug: nominee.slug,
              hashtag: '',
              hometown: '',
              secondaryName: '',
              knownFor: '',
              image: src,
              imageThumb: src,
              category: categories.find((category) => category.id === nomineeCategory),
              tags: [],
              platform: nominee.program_platform,
              url: nominee.url,
            })
          })
        })

        this.$store.dispatch('setRounds', rounds)
        this.$store.dispatch('setCategories', categories)
        this.$store.dispatch('setNominees', nominees)
        this.$store.dispatch('setLoaded', true)
      }).catch(() => {
        this.$store.dispatch('setLoaded', true)
        this.$store.dispatch('setFailedFetch', true);
    })
  },
}
</script>



// WEBPACK FOOTER //
// src/App.vue